"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutOptionsComponent = LayoutOptionsComponent;
const lodash_1 = __importDefault(require("lodash"));
const react_1 = __importStar(require("react"));
const react_2 = require("react");
const bootstrap_1 = require("@mwater/react-library/lib/bootstrap");
const layoutOptions_1 = require("./layoutOptions");
const ColorComponent_1 = __importDefault(require("../ColorComponent"));
const FontStyleEditor_1 = require("./FontStyleEditor");
const immer_1 = __importDefault(require("immer"));
const file_saver_1 = __importDefault(require("file-saver"));
function LayoutOptionsComponent(props) {
    const [previewSize, setPreviewSize] = (0, react_2.useState)(2);
    const layoutOptions = (0, layoutOptions_1.getLayoutOptions)(props.design);
    function setLayoutOptions(layoutOptions) {
        props.onDesignChange({ ...props.design, layoutOptions });
    }
    const isCustomized = !lodash_1.default.isEqual(layoutOptions, (0, layoutOptions_1.getDefaultLayoutOptions)(props.design.style));
    const sizeOptions = (0, react_1.useMemo)(() => [
        { value: { width: 360, height: 640 }, label: T `Phone (360x640)` },
        { value: { width: 768, height: 1024 }, label: T `Tablet (768x1024)` },
        { value: { width: 1000, height: 800 }, label: T `Laptop (1000x800)` },
        { value: { width: 1280, height: 1024 }, label: T `Desktop (1280x1024)` }
    ], []);
    return (react_1.default.createElement("div", { style: { display: "grid", gridTemplateRows: "auto 1fr", gridTemplateColumns: "360px 1fr", height: "100%" } },
        react_1.default.createElement("div", { style: { padding: "5px 10px 5px 0px", gridRow: "1 / 3", overflowY: "auto" } },
            react_1.default.createElement("h5", null, T `Theme`),
            react_1.default.createElement(ThemeToggle, { theme: props.design.style, onChange: (theme) => {
                    if (isCustomized) {
                        if (!confirm(T `Are you sure you want to change the theme? Your customizations will be lost.`))
                            return;
                    }
                    props.onDesignChange({ ...props.design, style: theme, layoutOptions: (0, layoutOptions_1.getDefaultLayoutOptions)(theme) });
                }, isCustomized: isCustomized }),
            react_1.default.createElement("br", null),
            react_1.default.createElement(bootstrap_1.CollapsibleSection, { label: react_1.default.createElement("h5", { style: { display: "inline-block" } }, T `Customize Layout`), initiallyOpen: isCustomized },
                react_1.default.createElement(CustomizeLayout, { layoutOptions: layoutOptions, onLayoutOptionsChange: setLayoutOptions }))),
        react_1.default.createElement("div", { style: { textAlign: "center", padding: 3 } },
            react_1.default.createElement("span", { className: "text-muted" },
                T `Preview As:`,
                "\u00A0"),
            react_1.default.createElement(bootstrap_1.Toggle, { value: previewSize, onChange: setPreviewSize, size: "xs", options: sizeOptions.map((so, index) => ({ value: index, label: so.label })) })),
        react_1.default.createElement("div", { style: { overflow: "auto" } },
            react_1.default.createElement("div", { style: {
                    display: "grid",
                    gridTemplateColumns: `1fr ${sizeOptions[previewSize].value.width}px 1fr`,
                    gridTemplateRows: `1fr ${sizeOptions[previewSize].value.height}px 1fr`,
                    height: "100%",
                    border: "solid 1px #AAA"
                } },
                react_1.default.createElement("div", { style: { backgroundColor: "#888", gridColumn: "1 / 4" } }),
                react_1.default.createElement("div", { style: { backgroundColor: "#888" } }),
                react_1.default.createElement("div", { style: { height: "100%", display: "grid", gridTemplateRows: "auto 1fr" } },
                    react_1.default.createElement("div", { key: "quickfilters" }, (layoutOptions.hideQuickfiltersWidth !== 0) &&
                        (layoutOptions.hideQuickfiltersWidth == null ||
                            sizeOptions[previewSize].value.width > layoutOptions.hideQuickfiltersWidth)
                        ? props.quickfiltersView
                        : null),
                    props.dashboardView),
                react_1.default.createElement("div", { style: { backgroundColor: "#888" } }),
                react_1.default.createElement("div", { style: { backgroundColor: "#888", gridColumn: "1 / 4" } })))));
}
function ThemeToggle(props) {
    function renderStyleItem(theme) {
        const isActive = props.isCustomized ? theme == "custom" : (props.theme || "default") == theme;
        if (theme == "default") {
            return (react_1.default.createElement("a", { key: theme, className: isActive ? "list-group-item active" : "list-group-item", onClick: props.onChange.bind(null, "default") },
                react_1.default.createElement("div", null, T `Classic Dashboard`),
                react_1.default.createElement("div", { style: { opacity: 0.6 } }, T `Ideal for data display with minimal text`)));
        }
        if (theme == "greybg") {
            return (react_1.default.createElement("a", { key: theme, className: isActive ? "list-group-item active" : "list-group-item", onClick: props.onChange.bind(null, "greybg") },
                react_1.default.createElement("div", null, T `Framed Dashboard`),
                react_1.default.createElement("div", { style: { opacity: 0.6 } }, T `Each widget is white on a grey background`)));
        }
        if (theme == "story") {
            return (react_1.default.createElement("a", { key: theme, className: isActive ? "list-group-item active" : "list-group-item", onClick: props.onChange.bind(null, "story") },
                react_1.default.createElement("div", null, T `Story`),
                react_1.default.createElement("div", { style: { opacity: 0.6 } }, T `Ideal for data-driven storytelling with lots of text`)));
        }
        if (theme == "custom") {
            return (react_1.default.createElement("a", { key: theme, className: isActive ? "list-group-item active" : "list-group-item" },
                react_1.default.createElement("div", null, T `Custom`),
                react_1.default.createElement("div", { style: { opacity: 0.6 } }, T `Customized theme`)));
        }
        return null;
    }
    return (react_1.default.createElement("div", { className: "list-group" },
        renderStyleItem("default"),
        renderStyleItem("greybg"),
        renderStyleItem("story"),
        props.isCustomized && renderStyleItem("custom")));
}
function CustomizeLayout(props) {
    const { layoutOptions, onLayoutOptionsChange } = props;
    const handleDownloadTheme = () => {
        const blob = new Blob([JSON.stringify(layoutOptions, null, 2)], { type: "application/json" });
        file_saver_1.default.saveAs(blob, "custom_theme.theme");
    };
    const handleUploadTheme = (event) => {
        const file = event.target.files?.[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (e) => {
                try {
                    const uploadedTheme = JSON.parse(e.target?.result);
                    onLayoutOptionsChange(uploadedTheme);
                }
                catch (error) {
                    alert(T `Invalid theme file`);
                }
            };
            reader.readAsText(file);
        }
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(bootstrap_1.CollapsiblePanel, { title: T `Text` },
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Title` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.titleWidgetFont, onChange: (titleWidgetFont) => {
                        onLayoutOptionsChange({ ...layoutOptions, titleWidgetFont });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Heading H1` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.textWidgetH1Font, onChange: (textWidgetH1Font) => {
                        onLayoutOptionsChange({ ...layoutOptions, textWidgetH1Font });
                    } }),
                react_1.default.createElement("div", { className: "mt-1" },
                    react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Top Margin:`, horizontal: true, labelMuted: true },
                        react_1.default.createElement(PixelsInput, { value: layoutOptions.textWidgetH1MarginTop, onChange: (textWidgetH1MarginTop) => {
                                onLayoutOptionsChange({ ...layoutOptions, textWidgetH1MarginTop: textWidgetH1MarginTop });
                            } })))),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Heading H2` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.textWidgetH2Font, onChange: (textWidgetH2Font) => {
                        onLayoutOptionsChange({ ...layoutOptions, textWidgetH2Font });
                    } }),
                react_1.default.createElement("div", { className: "mt-1" },
                    react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Top Margin:`, horizontal: true, labelMuted: true },
                        react_1.default.createElement(PixelsInput, { value: layoutOptions.textWidgetH2MarginTop, onChange: (textWidgetH2MarginTop) => {
                                onLayoutOptionsChange({ ...layoutOptions, textWidgetH2MarginTop: textWidgetH2MarginTop });
                            } })))),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Text` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.textWidgetFont, onChange: (textWidgetFont) => {
                        onLayoutOptionsChange({ ...layoutOptions, textWidgetFont });
                    } }),
                react_1.default.createElement("div", { className: "mt-1" },
                    react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Line Height:`, horizontal: true, labelMuted: true },
                        react_1.default.createElement(PixelsInput, { value: layoutOptions.textWidgetLineHeight, onChange: (textWidgetLineHeight) => {
                                onLayoutOptionsChange({ ...layoutOptions, textWidgetLineHeight: textWidgetLineHeight });
                            }, allowDefault: true, defaultLabel: T `Default` })),
                    react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Paragraph Spacing:`, horizontal: true, labelMuted: true },
                        react_1.default.createElement(PixelsInput, { value: layoutOptions.textWidgetParagraphSpacing, onChange: (textWidgetParagraphSpacing) => {
                                onLayoutOptionsChange({ ...layoutOptions, textWidgetParagraphSpacing: textWidgetParagraphSpacing });
                            } })))),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `List Line Height:`, horizontal: true },
                react_1.default.createElement(PixelsInput, { value: layoutOptions.textWidgetListLineHeight, onChange: (textWidgetListLineHeight) => {
                        onLayoutOptionsChange({ ...layoutOptions, textWidgetListLineHeight: textWidgetListLineHeight });
                    }, allowDefault: true, defaultLabel: T `Default` })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Chart Header Font` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.widgetHeaderFont, onChange: (widgetHeaderFont) => {
                        onLayoutOptionsChange({ ...layoutOptions, widgetHeaderFont });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Chart Footer Font` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.widgetFooterFont, onChange: (widgetFooterFont) => {
                        onLayoutOptionsChange({ ...layoutOptions, widgetFooterFont });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Chart Font` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.chartFont, onChange: (chartFont) => {
                        onLayoutOptionsChange({ ...layoutOptions, chartFont });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Table Font` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.tableFont, onChange: (tableFont) => {
                        onLayoutOptionsChange({ ...layoutOptions, tableFont });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Pivot Table Font` },
                react_1.default.createElement(FontStyleEditor_1.FontStyleEditor, { value: layoutOptions.pivotTableFont, onChange: (pivotTableFont) => {
                        onLayoutOptionsChange({ ...layoutOptions, pivotTableFont });
                    } }))),
        react_1.default.createElement(bootstrap_1.CollapsiblePanel, { title: T `Spacing` },
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Outer Padding:`, horizontal: true },
                react_1.default.createElement(PixelsInput, { value: layoutOptions.outerPadding, onChange: (outerPadding) => {
                        onLayoutOptionsChange({ ...layoutOptions, outerPadding: outerPadding });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Block Margins` },
                react_1.default.createElement(SpacingInput, { value: layoutOptions.blockMargin, onChange: (blockMargin) => {
                        onLayoutOptionsChange({ ...layoutOptions, blockMargin });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Block Padding` },
                react_1.default.createElement(SpacingInput, { value: layoutOptions.blockPadding, onChange: (blockPadding) => {
                        onLayoutOptionsChange({ ...layoutOptions, blockPadding });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Block Border Radius:`, horizontal: true },
                react_1.default.createElement(PixelsInput, { value: layoutOptions.blockBorderRadius, onChange: (blockBorderRadius) => {
                        onLayoutOptionsChange({ ...layoutOptions, blockBorderRadius: blockBorderRadius });
                    } }))),
        react_1.default.createElement(bootstrap_1.CollapsiblePanel, { title: T `Colors` },
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Background Color:`, horizontal: true },
                react_1.default.createElement(ColorComponent_1.default, { color: layoutOptions.backgroundColor, onChange: (backgroundColor) => {
                        onLayoutOptionsChange({ ...layoutOptions, backgroundColor: backgroundColor ?? "white" });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Block Background Color:`, horizontal: true },
                react_1.default.createElement(ColorComponent_1.default, { color: layoutOptions.blockBackgroundColor, onChange: (blockBackgroundColor) => {
                        onLayoutOptionsChange({ ...layoutOptions, blockBackgroundColor: blockBackgroundColor ?? "white" });
                    } })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Custom Colors` },
                react_1.default.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)', gap: '5px' } }, [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17].map((colorIndex) => (react_1.default.createElement(ColorComponent_1.default, { key: colorIndex, color: layoutOptions.customColors[colorIndex], onChange: (color) => {
                        onLayoutOptionsChange((0, immer_1.default)(layoutOptions, (draft) => {
                            draft.customColors[colorIndex] = color;
                        }));
                    } })))))),
        react_1.default.createElement(bootstrap_1.CollapsiblePanel, { title: T `Responsive Layout` },
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Collapse to Single Column` },
                react_1.default.createElement(WidthSelector, { value: layoutOptions.collapseColumnsWidth, onChange: (collapseColumnsWidth) => {
                        onLayoutOptionsChange({ ...layoutOptions, collapseColumnsWidth });
                    }, sign: "< " })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Hide Quickfilters` },
                react_1.default.createElement(WidthSelector, { value: layoutOptions.hideQuickfiltersWidth, onChange: (hideQuickfiltersWidth) => {
                        onLayoutOptionsChange({ ...layoutOptions, hideQuickfiltersWidth });
                    }, sign: "< ", includeAlways: true })),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Minimum Width (before scrolling or scaling)` },
                react_1.default.createElement(WidthSelector, { value: layoutOptions.minimumWidth, onChange: (minimumWidth) => {
                        onLayoutOptionsChange({ ...layoutOptions, minimumWidth });
                    }, sign: "< " }),
                react_1.default.createElement(bootstrap_1.FormGroup, { label: T `When Below Minimum Width` },
                    react_1.default.createElement(bootstrap_1.Toggle, { value: layoutOptions.belowMinimumWidth, onChange: (belowMinimumWidth) => {
                            onLayoutOptionsChange({ ...layoutOptions, belowMinimumWidth: belowMinimumWidth });
                        }, size: "sm", options: [
                            { value: "scroll", label: T `Scroll` },
                            { value: "scale", label: T `Scale` }
                        ] }))),
            react_1.default.createElement(bootstrap_1.FormGroup, { label: T `Maximum Width (before padding)` },
                react_1.default.createElement(WidthSelector, { value: layoutOptions.maximumWidth, onChange: (maximumWidth) => {
                        onLayoutOptionsChange({ ...layoutOptions, maximumWidth });
                    }, sign: "> " })),
            react_1.default.createElement(bootstrap_1.Checkbox, { value: layoutOptions.collapseSpacers, onChange: (collapseSpacers) => {
                    onLayoutOptionsChange({ ...layoutOptions, collapseSpacers });
                } }, T `Collapse Spacers on Mobile`)),
        react_1.default.createElement(bootstrap_1.CollapsiblePanel, { title: T `Download/Upload Theme`, initiallyClosed: true },
            react_1.default.createElement("div", { className: "mb-2 text-muted" }, T `Download or upload a custom theme to use for this dashboard.
          This saves the current theme as a theme file that you can then use on other dashboards by uploading it there.`),
            react_1.default.createElement("div", { style: { display: "flex", flexDirection: "column", marginTop: "10px", gap: "10px" } },
                react_1.default.createElement("button", { className: "btn btn-sm btn-secondary", onClick: handleDownloadTheme },
                    react_1.default.createElement("i", { className: "fas fa-download" }),
                    " ",
                    T `Download Custom Theme`),
                react_1.default.createElement("label", { className: "btn btn-sm btn-secondary" },
                    react_1.default.createElement("i", { className: "fas fa-upload" }),
                    " ",
                    T `Upload Custom Theme`,
                    react_1.default.createElement("input", { type: "file", accept: ".theme", style: { display: "none" }, onChange: handleUploadTheme }))))));
}
function SpacingInput(props) {
    return (react_1.default.createElement("div", { style: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', width: '100%' } },
        react_1.default.createElement("div", null, T `Top`),
        react_1.default.createElement("div", null, T `Bottom`),
        react_1.default.createElement("div", null, T `Left`),
        react_1.default.createElement("div", null, T `Right`),
        react_1.default.createElement(PixelsInput, { value: props.value.top, onChange: (top) => props.onChange({ ...props.value, top: top }) }),
        react_1.default.createElement(PixelsInput, { value: props.value.bottom, onChange: (bottom) => props.onChange({ ...props.value, bottom: bottom }) }),
        react_1.default.createElement(PixelsInput, { value: props.value.left, onChange: (left) => props.onChange({ ...props.value, left: left }) }),
        react_1.default.createElement(PixelsInput, { value: props.value.right, onChange: (right) => props.onChange({ ...props.value, right: right }) })));
}
function PixelsInput(props) {
    const options = [
        0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 15, 20, 25, 30, 35, 40
    ];
    return (react_1.default.createElement("div", { className: "dropdown" },
        react_1.default.createElement("a", { className: "dropdown-toggle", type: "button", id: "pixelsInputDropdown", "data-bs-toggle": "dropdown", "aria-expanded": "false" }, props.value === null ? (props.defaultLabel || T `Default`) : `${props.value}px`),
        react_1.default.createElement("ul", { className: "dropdown-menu", "aria-labelledby": "pixelsInputDropdown" },
            props.allowDefault && (react_1.default.createElement("li", { key: "default" },
                react_1.default.createElement("a", { className: "dropdown-item", href: "#", onClick: (e) => {
                        e.preventDefault();
                        props.onChange(null);
                    } }, props.defaultLabel || T `Default`))),
            options.map(option => (react_1.default.createElement("li", { key: option },
                react_1.default.createElement("a", { className: "dropdown-item", href: "#", onClick: (e) => {
                        e.preventDefault();
                        props.onChange(option);
                    } },
                    option,
                    "px")))))));
}
function WidthSelector(props) {
    // Create options array with conditional "Always" option
    const options = [
        { value: 400, label: `${props.sign}400px (${T `Phone`})` },
        { value: 600, label: `${props.sign}600px (${T `Small tablet`})` },
        { value: 800, label: `${props.sign}800px (${T `Tablet`})` },
        { value: 1000, label: `${props.sign}1000px (${T `Laptop`})` },
        { value: 1200, label: `${props.sign}1200px (${T `Desktop`})` },
        { value: 1600, label: `${props.sign}1600px (${T `Wide Desktop`})` }
    ];
    // Add "Always" option if requested
    if (props.includeAlways) {
        options.push({ value: 0, label: T `Always` });
    }
    return (react_1.default.createElement(bootstrap_1.Select, { value: props.value, onChange: props.onChange, nullLabel: T `N/A`, options: options }));
}
